import React, { useCallback } from 'react';

import styles from './FewShotDocuments.module.scss';
import { AIAgreementType } from '../queries/store';
import { PlusButton } from '../../../shared/button/PlusButton';
import { useAppDispatch, useAppSelector } from '../../../../hooks/react-redux';
import { toggleFewShotDocumentsUploadModal } from './store';
import { Scrollable } from '../../../shared/scrollable/Scrollable';
import { getAllDocumentNames } from '../../documents/store';
import { Button } from '../../../shared/button/Button';

interface FewShotAgreementTypesProps {
    selectAgreementType: (agreementTypeId: number) => void;
    aiAgreementTypes: AIAgreementType[];
}

export const FewShotAgreementTypes: React.FC<FewShotAgreementTypesProps> = ({ selectAgreementType, aiAgreementTypes }) => {
    const dispatch = useAppDispatch();
    const allDocumentNames = useAppSelector(getAllDocumentNames);

    const getRelevantDocumentNames = useCallback((id: number) => allDocumentNames.filter(({ agreementTypeId }) => agreementTypeId === id).map(({ documentName }) => documentName), [allDocumentNames]);

    const openUploadModal = useCallback(() => dispatch(toggleFewShotDocumentsUploadModal(true)), [dispatch]);

    return (
        <div className={styles.fewShotAgreementTypesWrapper}>
            <div className={styles.fewShotAgreementTypesHeader}>
                <div className={styles.fewShotAgreementTypesLabel}>Agreement Types</div>
                <PlusButton onClick={openUploadModal} fontSize={25} />
            </div>
            <div className={styles.fewShotAgreementTypes}>
                <Scrollable>
                    <div className={styles.tilesWrapper}>
                        {aiAgreementTypes.map(({ agreementTypeId, agreementType }) => {
                            const documentNames = getRelevantDocumentNames(agreementTypeId);
                            return (
                                <div key={agreementTypeId} className={styles.agreementTypeTileWrapper}>
                                    <div className={styles.documentNamesWrapper}>
                                        <div className={styles.documentNamesHeader}>{agreementType}:</div>
                                        <div className={styles.documentNamesList}>
                                            <Scrollable>
                                                <div>
                                                    {documentNames.map((name, i) => <div className={styles.documentName} key={i}>{name}</div>)}
                                                </div>
                                            </Scrollable>
                                        </div>
                                    </div>
                                    <div className={styles.buttonWrapper}>
                                        <Button label='Configure' onClick={() => selectAgreementType(agreementTypeId)} />
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </Scrollable>
            </div>
        </div>
    );
};

